<!--大用户 - 用户管理 - 总用户列表 -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="48">
          <!-- 第一排 -->
          <a-col :md="6" :sm="12">
            <a-form-item label="所属片区">
              <a-select v-model="query.belongingArea" placeholder="请选择所属片区" allow-clear>
                <a-select-option v-for="(value, index) in zoneOptionList" :key="index" :value="value">
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编码">
              <a-input v-model="query.userCode" placeholder="请输入用户编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户名称">
              <a-input v-model="query.userName" placeholder="请输入用户名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="手机号码">
              <a-input v-model="query.phone" placeholder="请输入手机号码" allow-clear />
            </a-form-item>
          </a-col>
          <!-- 第二排 -->
          <a-col :md="6" :sm="12">
            <a-form-item label="水表编号">
              <a-input v-model="query.waterMeterNumber" placeholder="请输入水表编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="口径">
              <a-input v-model="query.caliber" placeholder="请输入口径" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="水表类型">
              <a-select v-model="query.waterMeterType" placeholder="请选择水表类型" allow-clear>
                <a-select-option :value="1">机械表</a-select-option>
                <a-select-option :value="2">远传表</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用水性质">
              <a-select v-model="query.waterType" placeholder="请选择用水性质" allow-clear>
                <a-select-option :value="1">居民用水</a-select-option>
                <a-select-option :value="2">非居民用水</a-select-option>
                <a-select-option :value="3">特种用水</a-select-option>
                <a-select-option :value="4">其他用水</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 第三排-操作按钮 -->
          <a-col :md="12" :sm="12" style="display: flex;">
            <div style="margin-bottom: 20px;">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="primary" style="margin-left: 12px"
                @click="downloadTemplate({ execlForm: true })">下载模板</a-button>
              <a-upload name="file" :multiple="false" @change="changeFile" :file-list="fileList"
                :customRequest="customRequest" style="display: inline-block;">
                <a-button type="primary" style="margin-left: 12px" v-action:importing>批量导入</a-button>
              </a-upload>

              <a-button type="primary" style="margin-left: 12px" @click="exportHandles()" v-action:export>导出</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- table 表格-->
    <a-table rowKey="id" :bordered="true"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange" :scroll="{ x: 1500 }">
      <span slot="caliber" slot-scope="text">
        DN{{ text }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>

    <!-- modal 新增or编辑框-->
    <a-modal :title="isUpdate ? '编辑' : '新增'" style="top: 20px" :width="800" :maskClosable="false"
      v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
      <a-form :form="addOrUpdateForm" class="tenant-form">
        <a-row class="form-row" :gutter="16">
          <!-- 用户编码 user_code userCode -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户编码">
              <a-input placeholder="请输入用户编码" style="width: 100%"
                v-decorator="['userCode', { rules: [{ required: true, message: '请输入用户编码' }] }]" />
            </a-form-item>
          </a-col>

          <!-- 水表编号 water_meter_number waterMeterNumber -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表编号">
              <a-input placeholder="请输入水表编号" style="width: 100%"
                v-decorator="['waterMeterNumber', { rules: [{ required: true, message: '请输入水表编号' }] }]" />
            </a-form-item>
          </a-col>

          <!-- 用户名称 user_name userName -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户名称">
              <a-input placeholder="请输入用户名称" style="width: 100%"
                v-decorator="['userName', { rules: [{ required: true, message: '请输入用户名称' }] }]" />
            </a-form-item>
          </a-col>

          <!-- 水表类型 water_meter_type waterMeterType -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表类型">
              <a-select placeholder="请选择水表类型" style="width: 100%" @change="handleChange"
                v-decorator="['waterMeterType', { rules: [{ required: true, message: '请输入水表类型' }] }]">
                <a-select-option v-for="(item, index) in waterMeterTypeList" :key="index" :value="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <!-- 用户地址 user_address userAddress -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户地址">
              <a-input placeholder="请输入用户地址" style="width: 100%"
                v-decorator="['userAddress', { rules: [{ required: true, message: '请输入用户地址' }] }]" />
            </a-form-item>
          </a-col>

          <!-- 安装日期 install_date installDate -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装日期">
              <a-date-picker style="width: 100%" v-decorator="['installDate']" valueFormat="YYYY-MM-DD" />
            </a-form-item>
          </a-col>

          <!-- 手机号码 phone -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
              <a-input placeholder="请输入手机号码" style="width: 100%" v-decorator="['phone', {

              }]" />
            </a-form-item>
          </a-col>

          <!-- 口径 caliber -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="口径">
              <a-input placeholder="请输入口径" style="width: 100%" v-decorator="['caliber', {
                rules: [
                  {
                    validator: this.validateCaliber
                  }
                ]
              }]" />
            </a-form-item>
          </a-col>

          <!-- 用水性质 water_type waterType -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用水性质">
              <a-select placeholder="请选择用水性质" style="width: 100%" @change="handleChange"
                v-decorator="['waterType', { rules: [{ required: true, message: '请输入用水性质' }] }]">
                <a-select-option v-for="(item, index) in waterTypeList" :key="index" :value="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <!-- 厂家 manufacturer -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="厂家">
              <a-input placeholder="请输入厂家" style="width: 100%" v-decorator="['manufacturer']" />
            </a-form-item>
          </a-col>

          <!-- 所属片区 belongingArea -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属片区">
              <a-input placeholder="请输入所属片区" style="width: 100%" v-decorator="['belongingArea']" />
            </a-form-item>
          </a-col>

          <!-- 经度 longitude -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经度">
              <a-input placeholder="请输入经度" style="width: 100%" v-decorator="['longitude', {

              }]" />
            </a-form-item>
          </a-col>

          <!-- 纬度 longitude -->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="纬度">
              <a-input placeholder="请输入纬度" style="width: 100%" v-decorator="['latitude', {

              }]" />
            </a-form-item>
          </a-col>

        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import mixinViewModule from '@/mixin/common' //选项式混合导入
const columns = [ //表头参数
  {
    title: '用户编码',
    dataIndex: 'userCode',
    width: '120px', // 固定操作列宽度
    fixed: 'left'
  },
  {
    title: '用户名称',
    dataIndex: 'userName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '水表编号',
    dataIndex: 'waterMeterNumber',
    width: '150px',
    ellipsis: true
  },
  {
    title: '用户地址',
    dataIndex: 'userAddress',
    width: '200px',
    ellipsis: true
  },
  {
    title: '用水性质',
    dataIndex: 'waterTypeName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '手机号码',
    dataIndex: 'phone',
    width: '150px',
    ellipsis: true
  },
  {
    title: '所属片区',
    dataIndex: 'belongingArea',
    width: '150px',
    ellipsis: true
  },
  {
    title: '水表类型',
    dataIndex: 'waterMeterTypeName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '口径',
    dataIndex: 'caliber',
    width: '100px',
    ellipsis: true,
    scopedSlots: { customRender: 'caliber' }
  },
  {
    title: '厂家',
    dataIndex: 'manufacturer',
    width: '150px',
    ellipsis: true
  },
  {
    title: '安装日期',
    dataIndex: 'installDate',
    width: '150px',
    ellipsis: true
  },
  {
    title: '经度',
    dataIndex: 'longitude',
    width: '150px',
    ellipsis: true
  },
  {
    title: '纬度',
    dataIndex: 'latitude',
    width: '150px',
    ellipsis: true
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: '150px', // 固定操作列宽度
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'AllUserPage',
  data () {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      currentId: '',
      fileList: [],
      //通用接口
      getZoneListUrl: '/smart-water-major-users/major/users/user/group/belonging_area/select', //获取片区列表
      zoneOptionList: [], //片区列表
      //页面接口
      queryUrl: '/smart-water-major-users/major/users/user/page/select', //查询url
      addOrUpdateUrl: '/smart-water-major-users/major/users/user/user_info/insert/update', //新增or编辑url
      deleteUrl: '/smart-water-major-users/major/users/user/user_info/list/delete', //删除url
      exportDataUrl: 'smart-water-major-users/major/users/user/user_info/list/export', //导出url
      queryOneUrl: '/smart-water-major-users/major/users/user/id/select', //id编辑查询
      exportFileName: '总用户列表.xlsx', //导出名称
      downloadTemplateUrl: 'smart-water-major-users/major/users/user/user_info/null/list/export', // 模板
      downloadTemplateName: '用户列表模板.xlsx',
      query: { //查询对象

      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      //页面内属性
      waterMeterTypeList: [
        { value: 1, name: '机械表' },
        { value: 2, name: '远传表' }
      ],
      waterTypeList: [
        { value: 1, name: '居民用水' },
        { value: 2, name: '非居民用水' },
        { value: 3, name: '特种用水' },
        { value: 4, name: '其他' },
      ],
    }
  },
  created () {
    this.setSystemName();
  },
  mounted () {
    this.getZoneList();
  },
  methods: {
    //设置页面名称
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}大用户系统`)
    },
    // 口径数值验证
    validateCaliber (rule, value, callback) {
      if (!value) {
        // 如果为空，允许通过（因为可能不是必填项）
        callback();
        return;
      }

      // 检查是否为有效数字
      const numValue = Number(value);
      if (isNaN(numValue)) {
        callback(new Error('口径必须为数值类型'));
        return;
      }

      // 检查是否为整数
      if (!Number.isInteger(numValue)) {
        callback(new Error('口径必须为整数'));
        return;
      }

      // 检查是否为正数
      if (numValue <= 0) {
        callback(new Error('口径必须大于0'));
        return;
      }

      // 检查数值范围（根据实际业务需求调整）
      if (numValue > 1000) {
        callback(new Error('口径不能超过1000'));
        return;
      }

      callback();
    },
    getZoneList () {
      this.$http.get(this.getZoneListUrl).then((res) => {
        this.zoneOptionList = res.data
      })
    },
    // 重置
    resetList () {
      this.pagination.current = 1
      this.query = {}
      this.selectedRows = []
      this.queryList()
    },
    handleChange (value) {
      console.log(`selected ${value}`);
    },
    changeFile (info) {
      // 上传文件
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    customRequest (data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.importLoading = true

      axios.post(`${process.env.VUE_APP_API_BASE_URL}smart-water-major-users/major/users/user/user_info/list/import/export`, formData, {
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        },
        responseType: 'blob'
      })
        .then(response => {
          const blob = response.data;
          console.log('获取到blob:', blob);
          if (blob.size == 0) {
            this.$message.success('导入成功');
          } else {
            // 下载逻辑
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `用户信息表_${new Date().getTime()}.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);

            this.$message.warning('导入成功,但有错误数据,请查看');
          }
        })
        .catch(error => {
          console.log('导入失败:', error);
          this.$message.error('下载失败');
        })
        .finally(() => {
          this.resetList();
          this.importLoading = false
        })
    },
    exportHandles () {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`, {
        params: this.query,
        responseType: 'blob',
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        }
      })
        .then(response => {
          console.log('导出响应:', response);
          const blob = response.data;
          // 下载逻辑
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = this.exportFileName;
          link.click();
          window.URL.revokeObjectURL(url);

          this.$message.success('导出成功');
        })
        .catch(error => {
          console.log('导出失败:', error);
          this.$message.error('下载失败');
        })
        .finally(() => {
          this.resetList();
          this.importLoading = false
        })
    }

  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
